import PatternFillType from "./patternFill";

class PatternFills {
    public solid: string = 'M 0 0';
    public fallingDiagonal: string = 'M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11';
    public climbingDiagonal: string = 'M 0 10 L 10 0 M -1 1 L 1 -1 M 9 11 L 11 9';
    public vertical: string = 'M 3 0 L 3 10 M 8 0 L 8 10';
    public horizontal: string = 'M 0 3 L 10 3 M 0 8 L 10 8';
    public strangeS: string = 'M 0 3 L 5 3 L 5 0 M 5 10 L 5 7 L 10 7';
    public squares: string = 'M 3 3 L 8 3 L 8 8 L 3 8 Z';
    public circles: string = 'M 5 5 m -4 0 a 4 4 0 1 1 8 0 a 4 4 0 1 1 -8 0';
    public strangeZ: string = 'M 10 3 L 5 3 L 5 0 M 5 10 L 5 7 L 0 7';
    public diamonds: string = 'M 2 5 L 5 2 L 8 5 L 5 8 Z';
    public waves: string = 'M 0 0 L 5 10 L 10 0';
    public all: Array<string>;

    public constructor() {
        this.all = new Array<string>();
        this.all.push(this.fallingDiagonal);
        this.all.push(this.climbingDiagonal);
        this.all.push(this.vertical);
        this.all.push(this.horizontal);
        this.all.push(this.strangeS);
        this.all.push(this.squares);
        this.all.push(this.circles);
        this.all.push(this.strangeZ);
        this.all.push(this.diamonds);
        this.all.push(this.waves);
        this.all.push(this.solid);
    }

    public getByType(patternFillType: PatternFillType): string {
        switch (patternFillType) {
            case PatternFillType.FallingDiagonal:
                return this.fallingDiagonal;
            case PatternFillType.ClimbingDiagonal:
                return this.climbingDiagonal;
            case PatternFillType.Vertical:
                return this.vertical;
            case PatternFillType.Horizontal:
                return this.horizontal;
            case PatternFillType.StrangeS:
                return this.strangeS;
            case PatternFillType.Squares:
                return this.squares;
            case PatternFillType.Circles:
                return this.circles;
            case PatternFillType.StrangeZ:
                return this.strangeZ;
            case PatternFillType.Diamonds:
                return this.diamonds;
            case PatternFillType.Waves:
                return this.waves;        
            default:
                return this.solid;
        }
    }
}

const patternFills = new PatternFills();

export default patternFills;
